export default "__VITE_ASSET__DZ41olyb__"